export const GRID_LAYOUT_COLUMNS = 12;

export const GAP_SIZE = 8;

// Keep in sync with @GridLayout-row-height variable in less.
export const ROW_HEIGHT = 46;

export const MINIMAL_GRID_LAYOUT_WIDTH = 770; // Based on Grafana.

export function getColumnsCount(width: number) {
  return width < MINIMAL_GRID_LAYOUT_WIDTH ? 1 : GRID_LAYOUT_COLUMNS;
}

export function getLayoutPixelHeight(layoutRows: number) {
  return layoutRows * (ROW_HEIGHT + GAP_SIZE) - GAP_SIZE;
}

export function getColumnWidth(viewColumnsCount: number, gridWidth: number) {
  return (gridWidth - GAP_SIZE) / viewColumnsCount - GAP_SIZE;
}

export function getLayoutPixelWidth(layoutColums: number, columnWidth: number) {
  return layoutColums * (columnWidth + GAP_SIZE) - GAP_SIZE;
}
